import React, { useState } from "react";
import { ChromePicker } from "react-color";
import ReactApexChart from "react-apexcharts";
import "./ChartCard.css";

export default function ChartCard({ chartData, title, type, defaultColors }) {
  const [colors, setColors] = useState(defaultColors || []);
  const [showColorPicker, setShowColorPicker] = useState(false);

  const handleColorChange = (color, index) => {
    const updatedColors = [...colors];
    updatedColors[index] = color.hex;
    setColors(updatedColors);
  };

  const chartOptions = {
    chart: { type: type },
    labels: chartData.map((d) => d.name),
    colors: colors,
    legend: {
      position: "right",
    },
    title: {
      text: title,
      align: "center",
    },
  };

  return (
    <div className="chart-card">
      <div className="chart-card-header">
        <span className="chart-title">{title}</span>
        <button className="color-toggle-btn" onClick={() => setShowColorPicker(!showColorPicker)}>
          🎨
        </button>
      </div>

      <ReactApexChart options={chartOptions} series={chartData.map((d) => d.value)} type={type} height={350} />

      {showColorPicker && (
        <div className="color-picker-popup">
          {chartData.map((_, index) => (
            <div key={index} className="color-picker-row">
              <span className="color-label">Color {index + 1}</span>
              <ChromePicker
                color={colors[index] || "#ccc"}
                onChange={(color) => handleColorChange(color, index)}
                disableAlpha
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
